module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/techsupport-icon-bc4415f7f8b80ce72d7a2614462ddb9d.png";